"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var map = function map(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'map-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    // eslint-disable-next-line max-len
    d: 'M1.5523 2.39829C1.74251 2.25677 1.98843 2.21351 2.21551 2.28164L7.01807 3.72241L12.8181 2.2724C12.949 2.23968 13.0863 2.24287 13.2155 2.28164L18.2155 3.78164C18.5327 3.87681 18.75 4.1688 18.75 4.50001V17C18.75 17.2371 18.6379 17.4602 18.4477 17.6017C18.2575 17.7432 18.0116 17.7865 17.7845 17.7184L12.9819 16.2776L7.1819 17.7276C7.05101 17.7603 6.91372 17.7571 6.78449 17.7184L1.78449 16.2184C1.46725 16.1232 1.25 15.8312 1.25 15.5V3.00001C1.25 2.76293 1.36209 2.53981 1.5523 2.39829ZM13.75 14.942L17.25 15.992V5.05803L13.75 4.00803V14.942ZM12.25 3.96059V14.9144L7.75 16.0394V5.08559L12.25 3.96059ZM6.25 5.05803L2.75 4.00803V14.942L6.25 15.992V5.05803Z',
    fill: '#4B5563'
  }));
};

exports.map = map;